module.exports = __webpack_public_path__ + "static/showreel_2023-031367b89fcc572620fc45ab7677b148.jpeg";